// Shared ag-psd canvas factory initialization.
// ag-psd needs this to produce canvas/imageData on layers.
// Called by both psd-import.js and psd-export.js.
import { initializeCanvas } from 'ag-psd';

let initialized = false;
export function ensurePsdCanvasInit() {
  if (initialized) return;
  initializeCanvas((w, h) => new OffscreenCanvas(w, h));
  initialized = true;
}
